module.exports = __webpack_public_path__ + "images/花筑村全景_08-2.jpg?v=a9b35a6d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_08-2.jpg
 ** module id = 101
 ** module chunks = 1 2
 **/